import ComicButtons from '@/shared/Activities/ComicActivity/ComicButtons';
import CraftButtons from '@/shared/Activities/CraftActivity/CraftButtons';
import ShortStoryButtons from '@/shared/Activities/ShortStoryActivity/ShortStoryButtons';
import SongButtons from '@/shared/Activities/SongActivity/SongButtons';
import WorksheetButtons from '@/shared/Activities/WorksheetActivity/WorksheetButtons';
import RealTimeButtons from '@/shared/Activities/RealTimeActivity/Launchers/RealTimeActivity/RealTimeButtons';

export default function ActivityButtons({ activity }) {
  if (!activity?.type) {
    return null;
  }

  const Buttons = {
    song: SongButtons,
    comic: ComicButtons,
    shortStory: ShortStoryButtons,
    craft: CraftButtons,
    worksheet: WorksheetButtons,
    pictureDictionary: WorksheetButtons,
    realTime: RealTimeButtons,
    storyWithQuestions: ShortStoryButtons,
  }[activity.type];

  return Buttons ? <Buttons activity={activity} /> : null;
}
